var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 w-100"},[_c('div',{staticClass:"text-h1"},[_vm._v("Product details page coming soon...")])])}]

export { render, staticRenderFns }